import React from 'react';

import './style.sass';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

const Nextjs = ({ listNextjs }) => {
    return (
        <div className="nextjs-pochtabank">
            <FullWrapper>
                <div className="nextjs-pochtabank__Wrapper">
                    <div className="nextjs-pochtabank__Subtitle">
                        Next.js обеспечил для проекта точки роста по&nbsp;производительности:
                    </div>

                    <div className="nextjs-pochtabank__Items">
                        {listNextjs.map((item, index) => (
                            <div className="nextjs-pochtabank__Item" key={index}>
                                <div className="nextjs-pochtabank__Circle" />
                                <div
                                    className="nextjs-pochtabank__Text"
                                    dangerouslySetInnerHTML={{ __html: item.text }}
                                />
                            </div>
                        ))}
                    </div>
                </div>
                <div className="nextjs-pochtabank__Inner">
                    <div className="nextjs-pochtabank__Left">
                        <div>
                            Самое главное что все перечисленное работает из&nbsp;коробки
                            и&nbsp;почти не&nbsp;требует настройки. Да, все это можно делать
                            и&nbsp;на&nbsp;JQuery/vanilla стеке, но&nbsp;это крайне неэффективно.
                            Потребовалось&nbsp;бы написать определенное количество велосипедов
                            и&nbsp;увеличить срок разработки проекта вместо того, чтобы использовать
                            проверенный и&nbsp;популярный в&nbsp;мировой практике инструмент.
                        </div>
                        <div>
                            Помимо жестких требований к&nbsp;скорости работы фронта, также нужно
                            было сохранить дружелюбность нового сайта к&nbsp;SEO. Есть миф, что
                            React и&nbsp;SEO плохо дружат. На&nbsp;самом деле технология SSR
                            полностью закрывает этот вопрос. Она позволяет отдавать скомпилированный
                            HTML&nbsp;SEO-роботам. Опыт и&nbsp;экспертиза команды
                            &laquo;Вебпрактик&raquo; также подтверждают, что проекты на&nbsp;базе
                            React из&nbsp;различных сфер отлично залетают в&nbsp;топы поисковых
                            выдач. А&nbsp;Google большое значение придает еще
                            и&nbsp;производительности frontend-части проекта.
                        </div>
                    </div>
                    <div className="nextjs-pochtabank__Right">
                        Помимо жестких требований к&nbsp;скорости работы фронта, также нужно было
                        сохранить дружелюбность нового сайта к&nbsp;SEO.
                    </div>
                </div>
                <img
                    src="/images/pic/new-pochtabank/nextjs.jpg"
                    alt="nextjs"
                    className="nextjs-pochtabank__Image"
                />

                <div className="nextjs-pochtabank__Description">
                    Есть еще одно предубеждение, что проекты на&nbsp;React делать сложнее и&nbsp;для
                    этого нужна большую команду. Но&nbsp;все зависит от&nbsp;задачи и&nbsp;опыта
                    разработчиков. Практический опыт &laquo;Вебпрактик&raquo; по&nbsp;разработке
                    сайтов крупным корпорациям показывает, что React повышает производительность
                    создания и&nbsp;развития проектов. Этот подход позволяет отдать часть работы
                    бэкендеров на&nbsp;клиентское приложение (теперь бэкенд не&nbsp;отвечает
                    за&nbsp;шаблоны). Но&nbsp;это только улучшает процесс коллаборации внутри
                    команды и&nbsp;задает четкие линии ответственности.
                </div>
            </FullWrapper>
        </div>
    );
};

export default Nextjs;
